export default {
  PLANNED: 'Planned',
  IN_TRANSIT_PICK_UP: 'In transit pick-up',
  ARRIVED_PICK_UP: 'Arrived pick-up',
  IN_TRANSIT_DROP_OFF: 'In-transit drop-off',
  ARRIVED_DROP_OFF: 'Arrived drop-off',
  DEPARTED_DROP_OFF: 'Departed drop-off',
  TRACKING_FAILED: 'Tracking Failed',
};
